import script from "./Email.vue?vue&type=script&lang=ts&setup=true"
export * from "./Email.vue?vue&type=script&lang=ts&setup=true"

import "./Email.vue?vue&type=style&index=0&id=19190f21&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19190f21"]])

export default __exports__